<template>
  <div v-html="content" contenteditable="true"></div>
</template>

<style lang="less">
  @import (reference) "~less/app";
  @import "~rubinred/content/less/rubinred-builder";

  /* cke top bar */
  .cke {
    border: none!important;
  }

  .cke_top {
    padding: 10px 10px 6px!important;
    box-shadow: 0 8px 17px 2px rgba(0,0,0,0.10), 0 3px 14px 2px rgba(0,0,0,0.10), 0 5px 5px -3px rgba(0,0,0,0.1);
    border: none!important;
    display: flex!important;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  a.cke_button {
    padding: 6px 8px!important;
  }

  a.cke_button_on,
  a.cke_button_off:hover,
  a.cke_button_off:focus,
  a.cke_button_off:active {
    padding: 5px 7px!important;
  }

  .cke_combo_text {
    line-height: 28px!important;
  }

  .cke_combo_arrow{
    margin: 12px 0 0;
  }


  /* cke bottom bar */
  .cke_bottom{
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.15);
  }

  /* cke editable content */
  .cke_editable:hover,
  .cke_editable:focus,
  .cke_editable.cke_focus{
    outline: 1px dashed @builder-default-background;
  }

  .cke_editable > span + *{
    margin-top: 0;
  }

  .cke_editable span[data-cke-magic-line] {
    border-top-color: @builder-default-background!important;

    span:first-child {
      border-right-color: @builder-default-background!important;
    }

    span:nth-child(2) {
      border-left-color: @builder-default-background!important;
    }

    span:nth-child(3){
      background-color: @builder-default-background!important;
    }
  }
</style>

<script>
  export default {
    props: ['content', 'index'],
    data() {
      return {
        editor: null
      }
    },

    created() {
      //Fix to ensure parsing of CKEditor widgets
      this.$root.$on('move-down-block', this.fixEditorContent);
      this.$root.$on('move-up-block', this.fixEditorContent);
    },

    mounted() {
      if (typeof window.CKEDITOR === 'undefined') {
        if (console) {
          console.error('CKEDITOR is missing (https://ckeditor.com/)');
        }
        return;
      }
      let config = Object.assign({}, require('js/ckeditor/config'), window.App.get('builder.editor', {}));
      this.editor = window.CKEDITOR.inline(this.$el, config);
      this.editor.on('change', this.onChange);
      this.editor.on('mode', this.onMode);
      this.editor.on('focus', this.onFocus);
      this.editor.on('blur', this.onBlur);
      this.editor.on('contentDom', this.onContentDom);

      this.editor.on('instanceReady', () => {
        document.getElementById('ck-top-bar').childNodes[0].style.display = 'none';
      });
    },

    beforeDestroy() {
      this.editor.destroy(true);
    },

    methods: {
      fixEditorContent() {
        //Fix to ensure parsing of CKEditor widgets
        setTimeout(() => {
          this.editor.setData(this.content);
        }, 0);
      },
      updateContent() {
        let content = this.editor.getData();
        if (content === this.content) {
          return;
        }
        this.$root.$emit('change-block-content', this.index, content);
      },
      onMode() {
        if (this.editor.mode === 'source') {
          let editable = this.editor.editable();
          editable.attachListener(editable, 'input', () => {
            this.updateContent();
          });
        }
      },
      onChange() {
        //Do not emit "change-block-content" event inside this call because it could produce cursor flickering.
      },
      onFocus(e) {
        this.$emit('focus', e, this.editor);
      },
      onBlur(e) {
        this.updateContent();
        this.$emit('blur', e, this.editor);
        document.getElementById('cke_'+this.editor.name).style.display = 'none';
      },
      onContentDom(e) {
        this.$emit('contentDom', e);
      },
      getData() {
        return this.editor ? this.editor.getData() : '';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/content/assets/js/components/BuilderEditableContent.vue